import { useCallback, useState } from 'react';

export const MEMBERS_LAYOUT_STORAGE_KEY = 'gym_members_layout_mode';
export const MEMBERS_LAYOUT_CLASSIC = 'classic';
export const MEMBERS_LAYOUT_TABLE = 'table';

function readStoredLayout() {
    try {
        const stored = localStorage.getItem(MEMBERS_LAYOUT_STORAGE_KEY);
        if (stored === MEMBERS_LAYOUT_TABLE || stored === MEMBERS_LAYOUT_CLASSIC) {
            return stored;
        }
    } catch {
        /* ignore */
    }
    return MEMBERS_LAYOUT_TABLE;
}

export default function useMembersLayoutMode() {
    const [layoutMode, setLayoutModeState] = useState(readStoredLayout);

    const setLayoutMode = useCallback((mode) => {
        setLayoutModeState(mode);
        try {
            localStorage.setItem(MEMBERS_LAYOUT_STORAGE_KEY, mode);
        } catch {
            /* ignore */
        }
    }, []);

    return {
        layoutMode,
        isTableLayout: layoutMode === MEMBERS_LAYOUT_TABLE,
        setLayoutMode,
    };
}
